import { ACHTransfersConfigType } from '../giftcard-ach-service.types';

export const ACHTransfersConfig: ACHTransfersConfigType = {
  clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
  frequency: 'MONTHLY',
  locations: [
    {
      locationId: 'a8bd1f53-6172-4f1f-b78b-50c7cf052151',
      active: false,
    },
    {
      locationId: '14b3cc58-aeb1-4d27-a3f8-90d2c40e80dc',
      active: true,
    },
    {
      locationId: '06f89534-d4f2-4efe-823b-b8fa74bbc6c5',
      active: true,
    },
  ],
  createdDate: '2020-01-01T00:00:00Z',
  modifiedDate: '2026-01-11T15:02:13.186Z',
  active: true,
};
